/**
 * Location Data and Geocoding Utilities
 * Common cities database and geocoding functions for Kundali calculations
 */

// Common cities database for instant geocoding (lat, lng, timezone UTC offset)
export const COMMON_CITIES = {
  // ==================== ANDHRA PRADESH ====================
  // Major Cities
  'vijayawada': { lat: 16.5062, lng: 80.6480, tz: 5.5, name: 'Vijayawada, Andhra Pradesh' },
  'visakhapatnam': { lat: 17.6868, lng: 83.2185, tz: 5.5, name: 'Visakhapatnam, Andhra Pradesh' },
  'vizag': { lat: 17.6868, lng: 83.2185, tz: 5.5, name: 'Visakhapatnam, Andhra Pradesh' },
  'guntur': { lat: 16.3067, lng: 80.4365, tz: 5.5, name: 'Guntur, Andhra Pradesh' },
  'nellore': { lat: 14.4426, lng: 79.9865, tz: 5.5, name: 'Nellore, Andhra Pradesh' },
  'kurnool': { lat: 15.8281, lng: 78.0373, tz: 5.5, name: 'Kurnool, Andhra Pradesh' },
  'rajahmundry': { lat: 17.0005, lng: 81.8040, tz: 5.5, name: 'Rajahmundry, Andhra Pradesh' },
  'rajamahendravaram': { lat: 17.0005, lng: 81.8040, tz: 5.5, name: 'Rajamahendravaram, Andhra Pradesh' },
  'kakinada': { lat: 16.9891, lng: 82.2475, tz: 5.5, name: 'Kakinada, Andhra Pradesh' },
  'tirupati': { lat: 13.6288, lng: 79.4192, tz: 5.5, name: 'Tirupati, Andhra Pradesh' },
  'anantapur': { lat: 14.6819, lng: 77.6006, tz: 5.5, name: 'Anantapur, Andhra Pradesh' },
  'kadapa': { lat: 14.4674, lng: 78.8241, tz: 5.5, name: 'Kadapa, Andhra Pradesh' },
  'cuddapah': { lat: 14.4674, lng: 78.8241, tz: 5.5, name: 'Kadapa, Andhra Pradesh' },
  'ongole': { lat: 15.5057, lng: 80.0499, tz: 5.5, name: 'Ongole, Andhra Pradesh' },
  'eluru': { lat: 16.7107, lng: 81.0952, tz: 5.5, name: 'Eluru, Andhra Pradesh' },
  'nandyal': { lat: 15.4786, lng: 78.4836, tz: 5.5, name: 'Nandyal, Andhra Pradesh' },
  'machilipatnam': { lat: 16.1875, lng: 81.1389, tz: 5.5, name: 'Machilipatnam, Andhra Pradesh' },
  'adoni': { lat: 15.6322, lng: 77.2747, tz: 5.5, name: 'Adoni, Andhra Pradesh' },
  'tenali': { lat: 16.2428, lng: 80.6400, tz: 5.5, name: 'Tenali, Andhra Pradesh' },
  'proddatur': { lat: 14.7502, lng: 78.5481, tz: 5.5, name: 'Proddatur, Andhra Pradesh' },
  'chittoor': { lat: 13.2172, lng: 79.1003, tz: 5.5, name: 'Chittoor, Andhra Pradesh' },
  'hindupur': { lat: 13.8297, lng: 77.4930, tz: 5.5, name: 'Hindupur, Andhra Pradesh' },
  'bhimavaram': { lat: 16.5449, lng: 81.5212, tz: 5.5, name: 'Bhimavaram, Andhra Pradesh' },
  'madanapalle': { lat: 13.5504, lng: 78.5028, tz: 5.5, name: 'Madanapalle, Andhra Pradesh' },
  'guntakal': { lat: 15.1711, lng: 77.3787, tz: 5.5, name: 'Guntakal, Andhra Pradesh' },
  'srikakulam': { lat: 18.2949, lng: 83.8935, tz: 5.5, name: 'Srikakulam, Andhra Pradesh' },
  'dharmavaram': { lat: 14.4143, lng: 77.7208, tz: 5.5, name: 'Dharmavaram, Andhra Pradesh' },
  'gudivada': { lat: 16.4349, lng: 80.9920, tz: 5.5, name: 'Gudivada, Andhra Pradesh' },
  'narasaraopet': { lat: 16.2346, lng: 80.0447, tz: 5.5, name: 'Narasaraopet, Andhra Pradesh' },
  'tadipatri': { lat: 14.9091, lng: 78.0092, tz: 5.5, name: 'Tadipatri, Andhra Pradesh' },
  'tadepalligudem': { lat: 16.8145, lng: 81.5270, tz: 5.5, name: 'Tadepalligudem, Andhra Pradesh' },
  'amaravati': { lat: 16.5730, lng: 80.3575, tz: 5.5, name: 'Amaravati, Andhra Pradesh' },
  'vizianagaram': { lat: 18.1067, lng: 83.3956, tz: 5.5, name: 'Vizianagaram, Andhra Pradesh' },
  'chilakaluripet': { lat: 16.0892, lng: 80.1672, tz: 5.5, name: 'Chilakaluripet, Andhra Pradesh' },
  'kavali': { lat: 14.9163, lng: 79.9939, tz: 5.5, name: 'Kavali, Andhra Pradesh' },
  'mangalagiri': { lat: 16.4307, lng: 80.5686, tz: 5.5, name: 'Mangalagiri, Andhra Pradesh' },
  'palakollu': { lat: 16.5190, lng: 81.7303, tz: 5.5, name: 'Palakollu, Andhra Pradesh' },
  'anakapalle': { lat: 17.6914, lng: 83.0038, tz: 5.5, name: 'Anakapalle, Andhra Pradesh' },
  'narasapuram': { lat: 16.4340, lng: 81.6977, tz: 5.5, name: 'Narasapuram, Andhra Pradesh' },
  'markapur': { lat: 15.7358, lng: 79.2700, tz: 5.5, name: 'Markapur, Andhra Pradesh' },
  'pithapuram': { lat: 17.1169, lng: 82.2528, tz: 5.5, name: 'Pithapuram, Andhra Pradesh' },
  'samalkot': { lat: 17.0530, lng: 82.1780, tz: 5.5, name: 'Samalkot, Andhra Pradesh' },
  'bobbili': { lat: 18.5757, lng: 83.3588, tz: 5.5, name: 'Bobbili, Andhra Pradesh' },
  'jaggaiahpet': { lat: 16.8918, lng: 80.0979, tz: 5.5, name: 'Jaggaiahpet, Andhra Pradesh' },
  'amalapuram': { lat: 16.5789, lng: 82.0061, tz: 5.5, name: 'Amalapuram, Andhra Pradesh' },
  'vinukonda': { lat: 16.0532, lng: 79.7394, tz: 5.5, name: 'Vinukonda, Andhra Pradesh' },
  'palasa': { lat: 18.7676, lng: 84.4152, tz: 5.5, name: 'Palasa, Andhra Pradesh' },
  'tanuku': { lat: 16.7564, lng: 81.6809, tz: 5.5, name: 'Tanuku, Andhra Pradesh' },
  'repalle': { lat: 16.0196, lng: 80.8296, tz: 5.5, name: 'Repalle, Andhra Pradesh' },
  'nidadavole': { lat: 16.9058, lng: 81.6722, tz: 5.5, name: 'Nidadavole, Andhra Pradesh' },
  'punganur': { lat: 13.3667, lng: 78.5833, tz: 5.5, name: 'Punganur, Andhra Pradesh' },
  'gudur': { lat: 14.1500, lng: 79.8500, tz: 5.5, name: 'Gudur, Andhra Pradesh' },
  'sullurpeta': { lat: 13.7833, lng: 80.0167, tz: 5.5, name: 'Sullurpeta, Andhra Pradesh' },
  'venkatagiri': { lat: 13.9667, lng: 79.5833, tz: 5.5, name: 'Venkatagiri, Andhra Pradesh' },
  'srikalahasti': { lat: 13.7500, lng: 79.7000, tz: 5.5, name: 'Srikalahasti, Andhra Pradesh' },
  'tirumala': { lat: 13.6833, lng: 79.3500, tz: 5.5, name: 'Tirumala, Andhra Pradesh' },
  'puttur': { lat: 13.4500, lng: 79.5500, tz: 5.5, name: 'Puttur, Andhra Pradesh' },
  'nagari': { lat: 13.3167, lng: 79.5833, tz: 5.5, name: 'Nagari, Andhra Pradesh' },
  'palamaner': { lat: 13.2000, lng: 78.7500, tz: 5.5, name: 'Palamaner, Andhra Pradesh' },
  'pileru': { lat: 13.6500, lng: 78.9500, tz: 5.5, name: 'Pileru, Andhra Pradesh' },
  'puttaparthi': { lat: 14.1653, lng: 77.8117, tz: 5.5, name: 'Puttaparthi, Andhra Pradesh' },
  'penukonda': { lat: 14.0833, lng: 77.4167, tz: 5.5, name: 'Penukonda, Andhra Pradesh' },
  'rayadurg': { lat: 14.7000, lng: 76.8500, tz: 5.5, name: 'Rayadurg, Andhra Pradesh' },
  'gooty': { lat: 15.1167, lng: 77.6333, tz: 5.5, name: 'Gooty, Andhra Pradesh' },
  'uravakonda': { lat: 14.9500, lng: 77.2667, tz: 5.5, name: 'Uravakonda, Andhra Pradesh' },
  'yemmiganur': { lat: 15.7667, lng: 77.4833, tz: 5.5, name: 'Yemmiganur, Andhra Pradesh' },
  'mantralayam': { lat: 15.8667, lng: 77.3833, tz: 5.5, name: 'Mantralayam, Andhra Pradesh' },
  'allagadda': { lat: 15.1333, lng: 78.5000, tz: 5.5, name: 'Allagadda, Andhra Pradesh' },
  'atmakur': { lat: 15.8833, lng: 78.5833, tz: 5.5, name: 'Atmakur, Andhra Pradesh' },
  'jammalamadugu': { lat: 14.8500, lng: 78.3833, tz: 5.5, name: 'Jammalamadugu, Andhra Pradesh' },
  'rayachoti': { lat: 14.0500, lng: 78.7500, tz: 5.5, name: 'Rayachoti, Andhra Pradesh' },
  'rajampet': { lat: 14.1833, lng: 79.1667, tz: 5.5, name: 'Rajampet, Andhra Pradesh' },
  'mydukur': { lat: 14.7333, lng: 78.7333, tz: 5.5, name: 'Mydukur, Andhra Pradesh' },
  'badvel': { lat: 14.7333, lng: 79.0500, tz: 5.5, name: 'Badvel, Andhra Pradesh' },
  'pulivendla': { lat: 14.4167, lng: 78.2333, tz: 5.5, name: 'Pulivendla, Andhra Pradesh' },
  'kandukur': { lat: 15.2167, lng: 79.9000, tz: 5.5, name: 'Kandukur, Andhra Pradesh' },
  'darsi': { lat: 15.7667, lng: 79.6833, tz: 5.5, name: 'Darsi, Andhra Pradesh' },
  'chirala': { lat: 15.8167, lng: 80.3500, tz: 5.5, name: 'Chirala, Andhra Pradesh' },
  'bapatla': { lat: 15.9000, lng: 80.4667, tz: 5.5, name: 'Bapatla, Andhra Pradesh' },
  'addanki': { lat: 15.8117, lng: 79.9730, tz: 5.5, name: 'Addanki, Andhra Pradesh' },
  'piduguralla': { lat: 16.4667, lng: 79.8833, tz: 5.5, name: 'Piduguralla, Andhra Pradesh' },
  'macherla': { lat: 16.4833, lng: 79.4333, tz: 5.5, name: 'Macherla, Andhra Pradesh' },
  'sattenapalle': { lat: 16.3917, lng: 80.1528, tz: 5.5, name: 'Sattenapalle, Andhra Pradesh' },
  'tadikonda': { lat: 16.4833, lng: 80.3667, tz: 5.5, name: 'Tadikonda, Andhra Pradesh' },
  'nuzvid': { lat: 16.7833, lng: 80.8500, tz: 5.5, name: 'Nuzvid, Andhra Pradesh' },
  'gannavaram': { lat: 16.5333, lng: 80.8000, tz: 5.5, name: 'Gannavaram, Andhra Pradesh' },
  'hanuman junction': { lat: 16.5833, lng: 80.9333, tz: 5.5, name: 'Hanuman Junction, Andhra Pradesh' },
  'pedana': { lat: 16.2667, lng: 81.1500, tz: 5.5, name: 'Pedana, Andhra Pradesh' },
  'challapalli': { lat: 16.1167, lng: 80.9333, tz: 5.5, name: 'Challapalli, Andhra Pradesh' },
  'tiruvuru': { lat: 16.9000, lng: 80.6000, tz: 5.5, name: 'Tiruvuru, Andhra Pradesh' },
  'nandigama': { lat: 16.7833, lng: 80.2833, tz: 5.5, name: 'Nandigama, Andhra Pradesh' },
  'kovvur': { lat: 17.0167, lng: 81.7333, tz: 5.5, name: 'Kovvur, Andhra Pradesh' },
  'narsapur': { lat: 16.4380, lng: 81.6995, tz: 5.5, name: 'Narsapur, Andhra Pradesh' },
  'akividu': { lat: 16.5833, lng: 81.3833, tz: 5.5, name: 'Akividu, Andhra Pradesh' },
  'undi': { lat: 16.4833, lng: 81.3000, tz: 5.5, name: 'Undi, Andhra Pradesh' },
  'mandapeta': { lat: 16.8667, lng: 81.9333, tz: 5.5, name: 'Mandapeta, Andhra Pradesh' },
  'ramachandrapuram': { lat: 16.8333, lng: 82.0333, tz: 5.5, name: 'Ramachandrapuram, Andhra Pradesh' },
  'ravulapalem': { lat: 16.7667, lng: 81.8500, tz: 5.5, name: 'Ravulapalem, Andhra Pradesh' },
  'tuni': { lat: 17.3500, lng: 82.5333, tz: 5.5, name: 'Tuni, Andhra Pradesh' },
  'peddapuram': { lat: 17.0833, lng: 82.1333, tz: 5.5, name: 'Peddapuram, Andhra Pradesh' },
  'gollaprolu': { lat: 17.0833, lng: 82.3333, tz: 5.5, name: 'Gollaprolu, Andhra Pradesh' },
  'rampachodavaram': { lat: 17.4333, lng: 81.7833, tz: 5.5, name: 'Rampachodavaram, Andhra Pradesh' },
  'narsipatnam': { lat: 17.6667, lng: 82.6167, tz: 5.5, name: 'Narsipatnam, Andhra Pradesh' },
  'yelamanchili': { lat: 17.5500, lng: 82.8667, tz: 5.5, name: 'Yelamanchili, Andhra Pradesh' },
  'chodavaram': { lat: 17.8333, lng: 82.9500, tz: 5.5, name: 'Chodavaram, Andhra Pradesh' },
  'madugula': { lat: 17.9167, lng: 82.8000, tz: 5.5, name: 'Madugula, Andhra Pradesh' },
  'araku': { lat: 18.3333, lng: 82.8667, tz: 5.5, name: 'Araku, Andhra Pradesh' },
  'paderu': { lat: 18.0667, lng: 82.6667, tz: 5.5, name: 'Paderu, Andhra Pradesh' },
  'salur': { lat: 18.5167, lng: 83.2167, tz: 5.5, name: 'Salur, Andhra Pradesh' },
  'parvathipuram': { lat: 18.7833, lng: 83.4167, tz: 5.5, name: 'Parvathipuram, Andhra Pradesh' },
  'rajam': { lat: 18.4500, lng: 83.6500, tz: 5.5, name: 'Rajam, Andhra Pradesh' },
  'narasannapeta': { lat: 18.4167, lng: 84.0500, tz: 5.5, name: 'Narasannapeta, Andhra Pradesh' },
  'ichapuram': { lat: 19.1167, lng: 84.6833, tz: 5.5, name: 'Ichapuram, Andhra Pradesh' },
  'palakonda': { lat: 18.6000, lng: 83.7500, tz: 5.5, name: 'Palakonda, Andhra Pradesh' },
  'tekkali': { lat: 18.6000, lng: 84.2333, tz: 5.5, name: 'Tekkali, Andhra Pradesh' },

  // ==================== TELANGANA ====================
  // Major Cities
  'hyderabad': { lat: 17.3850, lng: 78.4867, tz: 5.5, name: 'Hyderabad, Telangana' },
  'secunderabad': { lat: 17.4399, lng: 78.4983, tz: 5.5, name: 'Secunderabad, Telangana' },
  'warangal': { lat: 17.9784, lng: 79.5941, tz: 5.5, name: 'Warangal, Telangana' },
  'nizamabad': { lat: 18.6725, lng: 78.0941, tz: 5.5, name: 'Nizamabad, Telangana' },
  'karimnagar': { lat: 18.4386, lng: 79.1288, tz: 5.5, name: 'Karimnagar, Telangana' },
  'khammam': { lat: 17.2473, lng: 80.1514, tz: 5.5, name: 'Khammam, Telangana' },
  'ramagundam': { lat: 18.7500, lng: 79.4500, tz: 5.5, name: 'Ramagundam, Telangana' },
  'mahbubnagar': { lat: 16.7488, lng: 77.9855, tz: 5.5, name: 'Mahbubnagar, Telangana' },
  'mahabubnagar': { lat: 16.7488, lng: 77.9855, tz: 5.5, name: 'Mahabubnagar, Telangana' },
  'nalgonda': { lat: 17.0500, lng: 79.2667, tz: 5.5, name: 'Nalgonda, Telangana' },
  'adilabad': { lat: 19.6641, lng: 78.5320, tz: 5.5, name: 'Adilabad, Telangana' },
  'suryapet': { lat: 17.1400, lng: 79.6200, tz: 5.5, name: 'Suryapet, Telangana' },
  'siddipet': { lat: 18.1000, lng: 78.8500, tz: 5.5, name: 'Siddipet, Telangana' },
  'miryalaguda': { lat: 16.8833, lng: 79.5667, tz: 5.5, name: 'Miryalaguda, Telangana' },
  'mancherial': { lat: 18.8667, lng: 79.4333, tz: 5.5, name: 'Mancherial, Telangana' },
  'jagtial': { lat: 18.7917, lng: 78.9167, tz: 5.5, name: 'Jagtial, Telangana' },
  'nirmal': { lat: 19.0833, lng: 78.3500, tz: 5.5, name: 'Nirmal, Telangana' },
  'bodhan': { lat: 18.6667, lng: 77.8833, tz: 5.5, name: 'Bodhan, Telangana' },
  'kamareddy': { lat: 18.3167, lng: 78.3333, tz: 5.5, name: 'Kamareddy, Telangana' },
  'armoor': { lat: 18.7833, lng: 78.2833, tz: 5.5, name: 'Armoor, Telangana' },
  'sangareddy': { lat: 17.6167, lng: 78.0833, tz: 5.5, name: 'Sangareddy, Telangana' },
  'medak': { lat: 18.0500, lng: 78.2667, tz: 5.5, name: 'Medak, Telangana' },
  'zaheerabad': { lat: 17.6833, lng: 77.6000, tz: 5.5, name: 'Zaheerabad, Telangana' },
  'narayanpet': { lat: 16.7333, lng: 77.4833, tz: 5.5, name: 'Narayanpet, Telangana' },
  'gadwal': { lat: 16.2300, lng: 77.7900, tz: 5.5, name: 'Gadwal, Telangana' },
  'wanaparthy': { lat: 16.3667, lng: 78.0667, tz: 5.5, name: 'Wanaparthy, Telangana' },
  'nagarkurnool': { lat: 16.4833, lng: 78.3167, tz: 5.5, name: 'Nagarkurnool, Telangana' },
  'shadnagar': { lat: 17.0667, lng: 78.2000, tz: 5.5, name: 'Shadnagar, Telangana' },
  'vikarabad': { lat: 17.3333, lng: 77.9000, tz: 5.5, name: 'Vikarabad, Telangana' },
  'tandur': { lat: 17.2500, lng: 77.5667, tz: 5.5, name: 'Tandur, Telangana' },
  'pargi': { lat: 17.2167, lng: 77.7667, tz: 5.5, name: 'Pargi, Telangana' },
  'bhongir': { lat: 17.5167, lng: 78.8833, tz: 5.5, name: 'Bhongir, Telangana' },
  'bhuvanagiri': { lat: 17.5167, lng: 78.8833, tz: 5.5, name: 'Bhuvanagiri, Telangana' },
  'yadadri': { lat: 17.5917, lng: 78.9333, tz: 5.5, name: 'Yadadri, Telangana' },
  'pochampalli': { lat: 17.3667, lng: 78.8333, tz: 5.5, name: 'Pochampalli, Telangana' },
  'choutuppal': { lat: 17.2500, lng: 78.9167, tz: 5.5, name: 'Choutuppal, Telangana' },
  'devarakonda': { lat: 16.6833, lng: 79.0333, tz: 5.5, name: 'Devarakonda, Telangana' },
  'nakrekal': { lat: 16.9500, lng: 79.4333, tz: 5.5, name: 'Nakrekal, Telangana' },
  'huzurnagar': { lat: 16.9000, lng: 79.8833, tz: 5.5, name: 'Huzurnagar, Telangana' },
  'kodad': { lat: 16.9833, lng: 79.9667, tz: 5.5, name: 'Kodad, Telangana' },
  'huzurabad': { lat: 18.1167, lng: 79.4000, tz: 5.5, name: 'Huzurabad, Telangana' },
  'peddapalli': { lat: 18.6167, lng: 79.3833, tz: 5.5, name: 'Peddapalli, Telangana' },
  'sultanabad': { lat: 18.8500, lng: 79.5333, tz: 5.5, name: 'Sultanabad, Telangana' },
  'bellampalli': { lat: 19.0500, lng: 79.4833, tz: 5.5, name: 'Bellampalli, Telangana' },
  'mandamarri': { lat: 19.0000, lng: 79.4667, tz: 5.5, name: 'Mandamarri, Telangana' },
  'godavarikhani': { lat: 18.7500, lng: 79.5333, tz: 5.5, name: 'Godavarikhani, Telangana' },
  'metpalli': { lat: 18.8333, lng: 78.6000, tz: 5.5, name: 'Metpalli, Telangana' },
  'korutla': { lat: 18.8167, lng: 78.7167, tz: 5.5, name: 'Korutla, Telangana' },
  'jagityal': { lat: 18.7917, lng: 78.9167, tz: 5.5, name: 'Jagityal, Telangana' },
  'dharmapuri': { lat: 18.9500, lng: 79.1167, tz: 5.5, name: 'Dharmapuri, Telangana' },
  'bhadrachalam': { lat: 17.6667, lng: 80.8833, tz: 5.5, name: 'Bhadrachalam, Telangana' },
  'kothagudem': { lat: 17.5500, lng: 80.6167, tz: 5.5, name: 'Kothagudem, Telangana' },
  'yellandu': { lat: 17.6000, lng: 80.3333, tz: 5.5, name: 'Yellandu, Telangana' },
  'palvancha': { lat: 17.5833, lng: 80.7000, tz: 5.5, name: 'Palvancha, Telangana' },
  'madhira': { lat: 16.9333, lng: 80.3833, tz: 5.5, name: 'Madhira, Telangana' },
  'sattupalli': { lat: 17.2500, lng: 80.8667, tz: 5.5, name: 'Sattupalli, Telangana' },
  'mulugu': { lat: 18.1833, lng: 80.0167, tz: 5.5, name: 'Mulugu, Telangana' },
  'mahabubabad': { lat: 17.5917, lng: 80.0000, tz: 5.5, name: 'Mahabubabad, Telangana' },
  'dornakal': { lat: 17.4500, lng: 80.1500, tz: 5.5, name: 'Dornakal, Telangana' },
  'narsampet': { lat: 17.9333, lng: 79.8833, tz: 5.5, name: 'Narsampet, Telangana' },
  'parkal': { lat: 18.2000, lng: 79.7000, tz: 5.5, name: 'Parkal, Telangana' },
  'jangaon': { lat: 17.7333, lng: 79.1833, tz: 5.5, name: 'Jangaon, Telangana' },
  'station ghanpur': { lat: 17.6833, lng: 79.4333, tz: 5.5, name: 'Station Ghanpur, Telangana' },
  'bhupalpally': { lat: 18.4333, lng: 79.8667, tz: 5.5, name: 'Bhupalpally, Telangana' },
  'chennur': { lat: 19.0167, lng: 79.1167, tz: 5.5, name: 'Chennur, Telangana' },
  'kyathampalli': { lat: 19.0000, lng: 78.0833, tz: 5.5, name: 'Kyathampalli, Telangana' },
  'bhainsa': { lat: 19.1000, lng: 77.9667, tz: 5.5, name: 'Bhainsa, Telangana' },
  'mudhole': { lat: 19.2500, lng: 78.0833, tz: 5.5, name: 'Mudhole, Telangana' },
  'boath': { lat: 19.4333, lng: 78.4833, tz: 5.5, name: 'Boath, Telangana' },
  'jainoor': { lat: 19.1833, lng: 78.9500, tz: 5.5, name: 'Jainoor, Telangana' },
  'sirpur': { lat: 18.8500, lng: 79.5667, tz: 5.5, name: 'Sirpur, Telangana' },
  'shamshabad': { lat: 17.2667, lng: 78.3833, tz: 5.5, name: 'Shamshabad, Telangana' },
  'ibrahimpatnam': { lat: 17.1000, lng: 78.5833, tz: 5.5, name: 'Ibrahimpatnam, Telangana' },
  'hayathnagar': { lat: 17.3333, lng: 78.5833, tz: 5.5, name: 'Hayathnagar, Telangana' },
  'lb nagar': { lat: 17.3500, lng: 78.5500, tz: 5.5, name: 'LB Nagar, Telangana' },
  'dilsukhnagar': { lat: 17.3667, lng: 78.5333, tz: 5.5, name: 'Dilsukhnagar, Telangana' },
  'kukatpally': { lat: 17.4833, lng: 78.4000, tz: 5.5, name: 'Kukatpally, Telangana' },
  'miyapur': { lat: 17.5000, lng: 78.3500, tz: 5.5, name: 'Miyapur, Telangana' },
  'kondapur': { lat: 17.4667, lng: 78.3500, tz: 5.5, name: 'Kondapur, Telangana' },
  'gachibowli': { lat: 17.4333, lng: 78.3333, tz: 5.5, name: 'Gachibowli, Telangana' },
  'madhapur': { lat: 17.4500, lng: 78.3833, tz: 5.5, name: 'Madhapur, Telangana' },
  'hitech city': { lat: 17.4500, lng: 78.3833, tz: 5.5, name: 'HITEC City, Telangana' },
  'jubilee hills': { lat: 17.4333, lng: 78.4000, tz: 5.5, name: 'Jubilee Hills, Telangana' },
  'banjara hills': { lat: 17.4200, lng: 78.4500, tz: 5.5, name: 'Banjara Hills, Telangana' },
  'ameerpet': { lat: 17.4333, lng: 78.4500, tz: 5.5, name: 'Ameerpet, Telangana' },
  'begumpet': { lat: 17.4333, lng: 78.4667, tz: 5.5, name: 'Begumpet, Telangana' },
  'malkajgiri': { lat: 17.4333, lng: 78.5333, tz: 5.5, name: 'Malkajgiri, Telangana' },
  'kapra': { lat: 17.4833, lng: 78.5667, tz: 5.5, name: 'Kapra, Telangana' },
  'uppal': { lat: 17.4000, lng: 78.5667, tz: 5.5, name: 'Uppal, Telangana' },
  'medchal': { lat: 17.6500, lng: 78.4833, tz: 5.5, name: 'Medchal, Telangana' },
  'patancheru': { lat: 17.5333, lng: 78.2667, tz: 5.5, name: 'Patancheru, Telangana' },
  'shamirpet': { lat: 17.6167, lng: 78.5833, tz: 5.5, name: 'Shamirpet, Telangana' },
  'ghatkesar': { lat: 17.4500, lng: 78.6833, tz: 5.5, name: 'Ghatkesar, Telangana' },
  'keesara': { lat: 17.5167, lng: 78.6167, tz: 5.5, name: 'Keesara, Telangana' },

  // ==================== TAMIL NADU ====================
  // Major Cities
  'chennai': { lat: 13.0827, lng: 80.2707, tz: 5.5, name: 'Chennai, Tamil Nadu' },
  'coimbatore': { lat: 11.0168, lng: 76.9558, tz: 5.5, name: 'Coimbatore, Tamil Nadu' },
  'madurai': { lat: 9.9252, lng: 78.1198, tz: 5.5, name: 'Madurai, Tamil Nadu' },
  'tiruchirappalli': { lat: 10.7905, lng: 78.7047, tz: 5.5, name: 'Tiruchirappalli, Tamil Nadu' },
  'trichy': { lat: 10.7905, lng: 78.7047, tz: 5.5, name: 'Tiruchirappalli, Tamil Nadu' },
  'salem': { lat: 11.6643, lng: 78.1460, tz: 5.5, name: 'Salem, Tamil Nadu' },
  'tirunelveli': { lat: 8.7139, lng: 77.7567, tz: 5.5, name: 'Tirunelveli, Tamil Nadu' },
  'tiruppur': { lat: 11.1085, lng: 77.3411, tz: 5.5, name: 'Tiruppur, Tamil Nadu' },
  'vellore': { lat: 12.9165, lng: 79.1325, tz: 5.5, name: 'Vellore, Tamil Nadu' },
  'erode': { lat: 11.3410, lng: 77.7172, tz: 5.5, name: 'Erode, Tamil Nadu' },
  'thoothukkudi': { lat: 8.7642, lng: 78.1348, tz: 5.5, name: 'Thoothukudi, Tamil Nadu' },
  'tuticorin': { lat: 8.7642, lng: 78.1348, tz: 5.5, name: 'Thoothukudi, Tamil Nadu' },
  'thanjavur': { lat: 10.7870, lng: 79.1378, tz: 5.5, name: 'Thanjavur, Tamil Nadu' },
  'tanjore': { lat: 10.7870, lng: 79.1378, tz: 5.5, name: 'Thanjavur, Tamil Nadu' },
  'dindigul': { lat: 10.3624, lng: 77.9695, tz: 5.5, name: 'Dindigul, Tamil Nadu' },
  'cuddalore': { lat: 11.7480, lng: 79.7714, tz: 5.5, name: 'Cuddalore, Tamil Nadu' },
  'kanchipuram': { lat: 12.8342, lng: 79.7036, tz: 5.5, name: 'Kanchipuram, Tamil Nadu' },
  'nagercoil': { lat: 8.1833, lng: 77.4119, tz: 5.5, name: 'Nagercoil, Tamil Nadu' },
  'kanyakumari': { lat: 8.0883, lng: 77.5385, tz: 5.5, name: 'Kanyakumari, Tamil Nadu' },
  'kumbakonam': { lat: 10.9617, lng: 79.3881, tz: 5.5, name: 'Kumbakonam, Tamil Nadu' },
  'karur': { lat: 10.9601, lng: 78.0766, tz: 5.5, name: 'Karur, Tamil Nadu' },
  'ambur': { lat: 12.7883, lng: 78.7163, tz: 5.5, name: 'Ambur, Tamil Nadu' },
  'tiruvannamalai': { lat: 12.2253, lng: 79.0747, tz: 5.5, name: 'Tiruvannamalai, Tamil Nadu' },
  'hosur': { lat: 12.7409, lng: 77.8253, tz: 5.5, name: 'Hosur, Tamil Nadu' },
  'villupuram': { lat: 11.9395, lng: 79.4924, tz: 5.5, name: 'Villupuram, Tamil Nadu' },
  'nagapattinam': { lat: 10.7672, lng: 79.8420, tz: 5.5, name: 'Nagapattinam, Tamil Nadu' },
  'ramanathapuram': { lat: 9.3639, lng: 78.8395, tz: 5.5, name: 'Ramanathapuram, Tamil Nadu' },
  'pudukkottai': { lat: 10.3833, lng: 78.8001, tz: 5.5, name: 'Pudukkottai, Tamil Nadu' },
  'krishnagiri': { lat: 12.5186, lng: 78.2137, tz: 5.5, name: 'Krishnagiri, Tamil Nadu' },
  'dharmapuri tn': { lat: 12.1357, lng: 78.1602, tz: 5.5, name: 'Dharmapuri, Tamil Nadu' },
  'sivakasi': { lat: 9.4533, lng: 77.7967, tz: 5.5, name: 'Sivakasi, Tamil Nadu' },
  'virudhunagar': { lat: 9.5680, lng: 77.9624, tz: 5.5, name: 'Virudhunagar, Tamil Nadu' },
  'namakkal': { lat: 11.2189, lng: 78.1674, tz: 5.5, name: 'Namakkal, Tamil Nadu' },
  'tiruchengode': { lat: 11.3786, lng: 77.8930, tz: 5.5, name: 'Tiruchengode, Tamil Nadu' },
  'pollachi': { lat: 10.6609, lng: 76.9544, tz: 5.5, name: 'Pollachi, Tamil Nadu' },
  'rajapalayam': { lat: 9.4525, lng: 77.5530, tz: 5.5, name: 'Rajapalayam, Tamil Nadu' },
  'tirupur': { lat: 11.1085, lng: 77.3411, tz: 5.5, name: 'Tirupur, Tamil Nadu' },
  'udhagamandalam': { lat: 11.4102, lng: 76.6950, tz: 5.5, name: 'Ooty, Tamil Nadu' },
  'ooty': { lat: 11.4102, lng: 76.6950, tz: 5.5, name: 'Ooty, Tamil Nadu' },
  'coonoor': { lat: 11.3530, lng: 76.7959, tz: 5.5, name: 'Coonoor, Tamil Nadu' },
  'kodaikanal': { lat: 10.2381, lng: 77.4892, tz: 5.5, name: 'Kodaikanal, Tamil Nadu' },
  'palani': { lat: 10.4500, lng: 77.5167, tz: 5.5, name: 'Palani, Tamil Nadu' },
  'mahabalipuram': { lat: 12.6269, lng: 80.1928, tz: 5.5, name: 'Mahabalipuram, Tamil Nadu' },
  'pondicherry': { lat: 11.9416, lng: 79.8083, tz: 5.5, name: 'Puducherry' },
  'puducherry': { lat: 11.9416, lng: 79.8083, tz: 5.5, name: 'Puducherry' },
  'arani': { lat: 12.6674, lng: 79.2826, tz: 5.5, name: 'Arani, Tamil Nadu' },
  'arcot': { lat: 12.9050, lng: 79.3333, tz: 5.5, name: 'Arcot, Tamil Nadu' },
  'aruppukkottai': { lat: 9.5167, lng: 78.1000, tz: 5.5, name: 'Aruppukkottai, Tamil Nadu' },
  'attur': { lat: 11.5833, lng: 78.6000, tz: 5.5, name: 'Attur, Tamil Nadu' },
  'avinashi': { lat: 11.1894, lng: 77.2658, tz: 5.5, name: 'Avinashi, Tamil Nadu' },
  'bodinayakanur': { lat: 10.0167, lng: 77.3167, tz: 5.5, name: 'Bodinayakanur, Tamil Nadu' },
  'chengalpattu': { lat: 12.6833, lng: 79.9833, tz: 5.5, name: 'Chengalpattu, Tamil Nadu' },
  'chidambaram': { lat: 11.3992, lng: 79.6917, tz: 5.5, name: 'Chidambaram, Tamil Nadu' },
  'coimbatore north': { lat: 11.0500, lng: 76.9333, tz: 5.5, name: 'Coimbatore North, Tamil Nadu' },
  'coimbatore south': { lat: 10.9833, lng: 76.9667, tz: 5.5, name: 'Coimbatore South, Tamil Nadu' },
  'cumbum': { lat: 9.7333, lng: 77.2833, tz: 5.5, name: 'Cumbum, Tamil Nadu' },
  'devakottai': { lat: 9.9500, lng: 78.8333, tz: 5.5, name: 'Devakottai, Tamil Nadu' },
  'dharapuram': { lat: 10.7333, lng: 77.5167, tz: 5.5, name: 'Dharapuram, Tamil Nadu' },
  'gobichettipalayam': { lat: 11.4500, lng: 77.4333, tz: 5.5, name: 'Gobichettipalayam, Tamil Nadu' },
  'gudiyatham': { lat: 12.9500, lng: 78.8667, tz: 5.5, name: 'Gudiyatham, Tamil Nadu' },
  'harur': { lat: 12.0500, lng: 78.4833, tz: 5.5, name: 'Harur, Tamil Nadu' },
  'jayamkondam': { lat: 11.0667, lng: 79.3500, tz: 5.5, name: 'Jayamkondam, Tamil Nadu' },
  'kallakurichi': { lat: 11.7333, lng: 78.9500, tz: 5.5, name: 'Kallakurichi, Tamil Nadu' },
  'kangeyam': { lat: 10.9333, lng: 77.5500, tz: 5.5, name: 'Kangeyam, Tamil Nadu' },
  'karaikudi': { lat: 10.0667, lng: 78.7833, tz: 5.5, name: 'Karaikudi, Tamil Nadu' },
  'kovilpatti': { lat: 9.1667, lng: 77.8667, tz: 5.5, name: 'Kovilpatti, Tamil Nadu' },
  'lalgudi': { lat: 10.8833, lng: 78.8167, tz: 5.5, name: 'Lalgudi, Tamil Nadu' },
  'maduranthakam': { lat: 12.5000, lng: 79.8833, tz: 5.5, name: 'Maduranthakam, Tamil Nadu' },
  'manamadurai': { lat: 9.6833, lng: 78.4500, tz: 5.5, name: 'Manamadurai, Tamil Nadu' },
  'mannargudi': { lat: 10.6667, lng: 79.4500, tz: 5.5, name: 'Mannargudi, Tamil Nadu' },
  'mayiladuthurai': { lat: 11.1000, lng: 79.6500, tz: 5.5, name: 'Mayiladuthurai, Tamil Nadu' },
  'mettur': { lat: 11.7833, lng: 77.8000, tz: 5.5, name: 'Mettur, Tamil Nadu' },
  'mettupalayam': { lat: 11.2972, lng: 76.9408, tz: 5.5, name: 'Mettupalayam, Tamil Nadu' },
  'musiri': { lat: 10.9500, lng: 78.4333, tz: 5.5, name: 'Musiri, Tamil Nadu' },
  'nandivaram guduvancheri': { lat: 12.8333, lng: 80.0833, tz: 5.5, name: 'Nandivaram-Guduvancheri, Tamil Nadu' },
  'neyveli': { lat: 11.5500, lng: 79.5000, tz: 5.5, name: 'Neyveli, Tamil Nadu' },
  'oddanchatram': { lat: 10.5000, lng: 77.7500, tz: 5.5, name: 'Oddanchatram, Tamil Nadu' },
  'pallavaram': { lat: 12.9667, lng: 80.1500, tz: 5.5, name: 'Pallavaram, Tamil Nadu' },
  'panruti': { lat: 11.7667, lng: 79.5500, tz: 5.5, name: 'Panruti, Tamil Nadu' },
  'paramakudi': { lat: 9.5333, lng: 78.5833, tz: 5.5, name: 'Paramakudi, Tamil Nadu' },
  'pattukkottai': { lat: 10.4333, lng: 79.3167, tz: 5.5, name: 'Pattukkottai, Tamil Nadu' },
  'perambalur': { lat: 11.2333, lng: 78.8833, tz: 5.5, name: 'Perambalur, Tamil Nadu' },
  'perundurai': { lat: 11.2833, lng: 77.6000, tz: 5.5, name: 'Perundurai, Tamil Nadu' },
  'ponneri': { lat: 13.3333, lng: 80.2000, tz: 5.5, name: 'Ponneri, Tamil Nadu' },
  'ranipet': { lat: 12.9333, lng: 79.3333, tz: 5.5, name: 'Ranipet, Tamil Nadu' },
  'rasipuram': { lat: 11.4667, lng: 78.1833, tz: 5.5, name: 'Rasipuram, Tamil Nadu' },
  'sankarankovil': { lat: 9.1667, lng: 77.5333, tz: 5.5, name: 'Sankarankovil, Tamil Nadu' },
  'sankari': { lat: 11.4833, lng: 77.8833, tz: 5.5, name: 'Sankari, Tamil Nadu' },
  'sathyamangalam': { lat: 11.5000, lng: 77.2333, tz: 5.5, name: 'Sathyamangalam, Tamil Nadu' },
  'sattur': { lat: 9.3500, lng: 77.9167, tz: 5.5, name: 'Sattur, Tamil Nadu' },
  'sivaganga': { lat: 9.8500, lng: 78.4833, tz: 5.5, name: 'Sivaganga, Tamil Nadu' },
  'srirangam': { lat: 10.8500, lng: 78.7000, tz: 5.5, name: 'Srirangam, Tamil Nadu' },
  'srivilliputhur': { lat: 9.5167, lng: 77.6333, tz: 5.5, name: 'Srivilliputhur, Tamil Nadu' },
  'tenkasi': { lat: 8.9500, lng: 77.3167, tz: 5.5, name: 'Tenkasi, Tamil Nadu' },
  'theni': { lat: 10.0000, lng: 77.4833, tz: 5.5, name: 'Theni, Tamil Nadu' },
  'thiruvarur': { lat: 10.7667, lng: 79.6333, tz: 5.5, name: 'Thiruvarur, Tamil Nadu' },
  'tindivanam': { lat: 12.2333, lng: 79.6500, tz: 5.5, name: 'Tindivanam, Tamil Nadu' },
  'tiruttani': { lat: 13.1833, lng: 79.6167, tz: 5.5, name: 'Tiruttani, Tamil Nadu' },
  'tiruvallur': { lat: 13.1333, lng: 79.9167, tz: 5.5, name: 'Tiruvallur, Tamil Nadu' },
  'tiruvarur': { lat: 10.7667, lng: 79.6333, tz: 5.5, name: 'Tiruvarur, Tamil Nadu' },
  'udumalaipettai': { lat: 10.5833, lng: 77.2500, tz: 5.5, name: 'Udumalaipettai, Tamil Nadu' },
  'ulundurpettai': { lat: 11.7167, lng: 78.8167, tz: 5.5, name: 'Ulundurpettai, Tamil Nadu' },
  'uthangarai': { lat: 12.0000, lng: 78.3333, tz: 5.5, name: 'Uthangarai, Tamil Nadu' },
  'vadakkuvalliyur': { lat: 8.2000, lng: 77.5333, tz: 5.5, name: 'Vadakkuvalliyur, Tamil Nadu' },
  'valparai': { lat: 10.3333, lng: 76.9500, tz: 5.5, name: 'Valparai, Tamil Nadu' },
  'vandalur': { lat: 12.8833, lng: 80.0833, tz: 5.5, name: 'Vandalur, Tamil Nadu' },
  'vandavasi': { lat: 12.5000, lng: 79.6000, tz: 5.5, name: 'Vandavasi, Tamil Nadu' },
  'vaniyambadi': { lat: 12.6833, lng: 78.6167, tz: 5.5, name: 'Vaniyambadi, Tamil Nadu' },
  'vedaranyam': { lat: 10.3667, lng: 79.8500, tz: 5.5, name: 'Vedaranyam, Tamil Nadu' },
  'vellakoil': { lat: 10.9333, lng: 77.7167, tz: 5.5, name: 'Vellakoil, Tamil Nadu' },
  'vikramasingapuram': { lat: 8.7167, lng: 77.2667, tz: 5.5, name: 'Vikramasingapuram, Tamil Nadu' },
  'walajapet': { lat: 12.9333, lng: 79.3667, tz: 5.5, name: 'Walajapet, Tamil Nadu' },
  'tambaram': { lat: 12.9167, lng: 80.1333, tz: 5.5, name: 'Tambaram, Tamil Nadu' },
  'chromepet': { lat: 12.9500, lng: 80.1333, tz: 5.5, name: 'Chromepet, Tamil Nadu' },
  'avadi': { lat: 13.1167, lng: 80.1000, tz: 5.5, name: 'Avadi, Tamil Nadu' },
  'ambattur': { lat: 13.1144, lng: 80.1549, tz: 5.5, name: 'Ambattur, Tamil Nadu' },
  'anna nagar': { lat: 13.0850, lng: 80.2100, tz: 5.5, name: 'Anna Nagar, Tamil Nadu' },
  't nagar': { lat: 13.0418, lng: 80.2341, tz: 5.5, name: 'T. Nagar, Tamil Nadu' },
  'mylapore': { lat: 13.0387, lng: 80.2692, tz: 5.5, name: 'Mylapore, Tamil Nadu' },
  'adyar': { lat: 13.0012, lng: 80.2565, tz: 5.5, name: 'Adyar, Tamil Nadu' },
  'velachery': { lat: 12.9815, lng: 80.2180, tz: 5.5, name: 'Velachery, Tamil Nadu' },
  'porur': { lat: 13.0382, lng: 80.1582, tz: 5.5, name: 'Porur, Tamil Nadu' },
  'madipakkam': { lat: 12.9667, lng: 80.2000, tz: 5.5, name: 'Madipakkam, Tamil Nadu' },
  'sholinganallur': { lat: 12.8992, lng: 80.2270, tz: 5.5, name: 'Sholinganallur, Tamil Nadu' },
  'egmore': { lat: 13.0731, lng: 80.2608, tz: 5.5, name: 'Egmore, Tamil Nadu' },
  'perambur': { lat: 13.1167, lng: 80.2333, tz: 5.5, name: 'Perambur, Tamil Nadu' },
  'royapuram': { lat: 13.1167, lng: 80.2833, tz: 5.5, name: 'Royapuram, Tamil Nadu' },
  'tondiarpet': { lat: 13.1333, lng: 80.2833, tz: 5.5, name: 'Tondiarpet, Tamil Nadu' },
  'thiruvottiyur': { lat: 13.1667, lng: 80.3000, tz: 5.5, name: 'Thiruvottiyur, Tamil Nadu' },
  'ennore': { lat: 13.2167, lng: 80.3167, tz: 5.5, name: 'Ennore, Tamil Nadu' },
  'manali': { lat: 13.1667, lng: 80.2500, tz: 5.5, name: 'Manali, Tamil Nadu' },
  'red hills': { lat: 13.1833, lng: 80.1833, tz: 5.5, name: 'Red Hills, Tamil Nadu' },
  'poonamallee': { lat: 13.0500, lng: 80.1000, tz: 5.5, name: 'Poonamallee, Tamil Nadu' },
  'sriperumbudur': { lat: 12.9600, lng: 79.9400, tz: 5.5, name: 'Sriperumbudur, Tamil Nadu' },
  'guindy': { lat: 13.0108, lng: 80.2206, tz: 5.5, name: 'Guindy, Tamil Nadu' },
  'nungambakkam': { lat: 13.0604, lng: 80.2446, tz: 5.5, name: 'Nungambakkam, Tamil Nadu' },
  'kilpauk': { lat: 13.0833, lng: 80.2500, tz: 5.5, name: 'Kilpauk, Tamil Nadu' },
  'kodambakkam': { lat: 13.0508, lng: 80.2228, tz: 5.5, name: 'Kodambakkam, Tamil Nadu' },
  'ashok nagar chennai': { lat: 13.0333, lng: 80.2167, tz: 5.5, name: 'Ashok Nagar, Tamil Nadu' },
  'thiruverkadu': { lat: 13.0667, lng: 80.1000, tz: 5.5, name: 'Thiruverkadu, Tamil Nadu' },
  'mogappair': { lat: 13.0833, lng: 80.1667, tz: 5.5, name: 'Mogappair, Tamil Nadu' },
  'koyambedu': { lat: 13.0694, lng: 80.1944, tz: 5.5, name: 'Koyambedu, Tamil Nadu' },

  // ==================== KARNATAKA (Nearby) ====================
  'bangalore': { lat: 12.9716, lng: 77.5946, tz: 5.5, name: 'Bengaluru, Karnataka' },
  'bengaluru': { lat: 12.9716, lng: 77.5946, tz: 5.5, name: 'Bengaluru, Karnataka' },
  'mysore': { lat: 12.2958, lng: 76.6394, tz: 5.5, name: 'Mysuru, Karnataka' },
  'mysuru': { lat: 12.2958, lng: 76.6394, tz: 5.5, name: 'Mysuru, Karnataka' },
  'mangalore': { lat: 12.9141, lng: 74.8560, tz: 5.5, name: 'Mangalore, Karnataka' },
  'mangaluru': { lat: 12.9141, lng: 74.8560, tz: 5.5, name: 'Mangaluru, Karnataka' },

  // ==================== KERALA (Nearby) ====================
  'kochi': { lat: 9.9312, lng: 76.2673, tz: 5.5, name: 'Kochi, Kerala' },
  'cochin': { lat: 9.9312, lng: 76.2673, tz: 5.5, name: 'Kochi, Kerala' },
  'thiruvananthapuram': { lat: 8.5241, lng: 76.9366, tz: 5.5, name: 'Thiruvananthapuram, Kerala' },
  'trivandrum': { lat: 8.5241, lng: 76.9366, tz: 5.5, name: 'Thiruvananthapuram, Kerala' },

  // ==================== OTHER MAJOR INDIAN CITIES ====================
  'delhi': { lat: 28.6139, lng: 77.2090, tz: 5.5, name: 'Delhi, India' },
  'new delhi': { lat: 28.6139, lng: 77.2090, tz: 5.5, name: 'New Delhi, India' },
  'mumbai': { lat: 19.0760, lng: 72.8777, tz: 5.5, name: 'Mumbai, India' },
  'kolkata': { lat: 22.5726, lng: 88.3639, tz: 5.5, name: 'Kolkata, India' },
  'pune': { lat: 18.5204, lng: 73.8567, tz: 5.5, name: 'Pune, India' },
  'ahmedabad': { lat: 23.0225, lng: 72.5714, tz: 5.5, name: 'Ahmedabad, India' },
  'jaipur': { lat: 26.9124, lng: 75.7873, tz: 5.5, name: 'Jaipur, India' },
  'lucknow': { lat: 26.8467, lng: 80.9462, tz: 5.5, name: 'Lucknow, India' },
  'varanasi': { lat: 25.3176, lng: 83.0068, tz: 5.5, name: 'Varanasi, India' },
  'bhopal': { lat: 23.2599, lng: 77.4126, tz: 5.5, name: 'Bhopal, India' },
  'indore': { lat: 22.7196, lng: 75.8577, tz: 5.5, name: 'Indore, India' },
  'nagpur': { lat: 21.1458, lng: 79.0882, tz: 5.5, name: 'Nagpur, India' },
  'surat': { lat: 21.1702, lng: 72.8311, tz: 5.5, name: 'Surat, India' },
  'patna': { lat: 25.6093, lng: 85.1376, tz: 5.5, name: 'Patna, India' },
  'chandigarh': { lat: 30.7333, lng: 76.7794, tz: 5.5, name: 'Chandigarh, India' },
  'amritsar': { lat: 31.6340, lng: 74.8723, tz: 5.5, name: 'Amritsar, India' },
  'ranchi': { lat: 23.3441, lng: 85.3096, tz: 5.5, name: 'Ranchi, India' },
  'bhubaneswar': { lat: 20.2961, lng: 85.8245, tz: 5.5, name: 'Bhubaneswar, India' },
  'guwahati': { lat: 26.1445, lng: 91.7362, tz: 5.5, name: 'Guwahati, India' },
  'ujjain': { lat: 23.1765, lng: 75.7885, tz: 5.5, name: 'Ujjain, India' },

  // ==================== INTERNATIONAL CITIES ====================
  'london': { lat: 51.5074, lng: -0.1278, tz: 0, name: 'London, UK' },
  'new york': { lat: 40.7128, lng: -74.0060, tz: -5, name: 'New York, USA' },
  'dubai': { lat: 25.2048, lng: 55.2708, tz: 4, name: 'Dubai, UAE' },
  'singapore': { lat: 1.3521, lng: 103.8198, tz: 8, name: 'Singapore' },
  'kuala lumpur': { lat: 3.1390, lng: 101.6869, tz: 8, name: 'Kuala Lumpur, Malaysia' },
  'sydney': { lat: -33.8688, lng: 151.2093, tz: 10, name: 'Sydney, Australia' },
  'melbourne': { lat: -37.8136, lng: 144.9631, tz: 10, name: 'Melbourne, Australia' },
  'toronto': { lat: 43.6532, lng: -79.3832, tz: -5, name: 'Toronto, Canada' },
  'vancouver': { lat: 49.2827, lng: -123.1207, tz: -8, name: 'Vancouver, Canada' },
  'san francisco': { lat: 37.7749, lng: -122.4194, tz: -8, name: 'San Francisco, USA' },
  'los angeles': { lat: 34.0522, lng: -118.2437, tz: -8, name: 'Los Angeles, USA' },
  'chicago': { lat: 41.8781, lng: -87.6298, tz: -6, name: 'Chicago, USA' },
  'houston': { lat: 29.7604, lng: -95.3698, tz: -6, name: 'Houston, USA' },
  'seattle': { lat: 47.6062, lng: -122.3321, tz: -8, name: 'Seattle, USA' },
  'boston': { lat: 42.3601, lng: -71.0589, tz: -5, name: 'Boston, USA' },
  'atlanta': { lat: 33.7490, lng: -84.3880, tz: -5, name: 'Atlanta, USA' },
  'dallas': { lat: 32.7767, lng: -96.7970, tz: -6, name: 'Dallas, USA' },
  'paris': { lat: 48.8566, lng: 2.3522, tz: 1, name: 'Paris, France' },
  'berlin': { lat: 52.5200, lng: 13.4050, tz: 1, name: 'Berlin, Germany' },
  'frankfurt': { lat: 50.1109, lng: 8.6821, tz: 1, name: 'Frankfurt, Germany' },
  'amsterdam': { lat: 52.3676, lng: 4.9041, tz: 1, name: 'Amsterdam, Netherlands' },
  'tokyo': { lat: 35.6762, lng: 139.6503, tz: 9, name: 'Tokyo, Japan' },
  'hong kong': { lat: 22.3193, lng: 114.1694, tz: 8, name: 'Hong Kong' },
  'shanghai': { lat: 31.2304, lng: 121.4737, tz: 8, name: 'Shanghai, China' },
  'beijing': { lat: 39.9042, lng: 116.4074, tz: 8, name: 'Beijing, China' },
  'bangkok': { lat: 13.7563, lng: 100.5018, tz: 7, name: 'Bangkok, Thailand' },
  'jakarta': { lat: -6.2088, lng: 106.8456, tz: 7, name: 'Jakarta, Indonesia' },
  'manila': { lat: 14.5995, lng: 120.9842, tz: 8, name: 'Manila, Philippines' },
  'colombo': { lat: 6.9271, lng: 79.8612, tz: 5.5, name: 'Colombo, Sri Lanka' },
  'kathmandu': { lat: 27.7172, lng: 85.3240, tz: 5.75, name: 'Kathmandu, Nepal' },
  'dhaka': { lat: 23.8103, lng: 90.4125, tz: 6, name: 'Dhaka, Bangladesh' },
  'karachi': { lat: 24.8607, lng: 67.0011, tz: 5, name: 'Karachi, Pakistan' },
  'lahore': { lat: 31.5204, lng: 74.3587, tz: 5, name: 'Lahore, Pakistan' },
  'islamabad': { lat: 33.6844, lng: 73.0479, tz: 5, name: 'Islamabad, Pakistan' },
  'muscat': { lat: 23.5880, lng: 58.3829, tz: 4, name: 'Muscat, Oman' },
  'doha': { lat: 25.2854, lng: 51.5310, tz: 3, name: 'Doha, Qatar' },
  'riyadh': { lat: 24.7136, lng: 46.6753, tz: 3, name: 'Riyadh, Saudi Arabia' },
  'jeddah': { lat: 21.4858, lng: 39.1925, tz: 3, name: 'Jeddah, Saudi Arabia' },
  'abu dhabi': { lat: 24.4539, lng: 54.3773, tz: 4, name: 'Abu Dhabi, UAE' },
  'kuwait city': { lat: 29.3759, lng: 47.9774, tz: 3, name: 'Kuwait City, Kuwait' },
  'bahrain': { lat: 26.0667, lng: 50.5577, tz: 3, name: 'Bahrain' },
};

/**
 * Search local city database (case-insensitive partial match)
 * @param {string} query - Search query
 * @returns {Array} Matching cities
 */
export const searchLocalCities = (query) => {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase().trim();
  return Object.entries(COMMON_CITIES)
    .filter(([key, city]) => key.includes(q) || city.name.toLowerCase().includes(q))
    .map(([, city]) => city)
    .filter((city, idx, arr) => arr.findIndex(c => c.name === city.name) === idx)
    .slice(0, 6);
};

/**
 * Geocode using OpenStreetMap Nominatim API
 * @param {string} query - Place name to search
 * @returns {Promise<Array>} Array of location results
 */
export const geocodePlaceAPI = async (query) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5&addressdetails=1`,
    { headers: { 'Accept-Language': 'en' } }
  );
  if (!response.ok) throw new Error('Geocoding failed');
  const results = await response.json();
  return results.map(r => ({
    lat: parseFloat(r.lat),
    lng: parseFloat(r.lon),
    name: r.display_name.split(',').slice(0, 3).join(',').trim(),
    tz: 5.5, // Default IST; user can adjust
  }));
};

/**
 * Get default coordinates for Ujjain (traditional reference point)
 * @returns {Object} Coordinates for Ujjain
 */
export const getDefaultCoordinates = () => ({
  lat: 23.1765,
  lng: 75.7885,
  tz: 5.5,
  name: 'Ujjain, India (Default)'
});

/**
 * Validate coordinates
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {boolean} Whether coordinates are valid
 */
export const isValidCoordinates = (lat, lng) => {
  return !isNaN(lat) && !isNaN(lng) &&
         lat >= -90 && lat <= 90 &&
         lng >= -180 && lng <= 180;
};
